import { Component, Vue, Watch } from 'vue-property-decorator';
import { IReportData, IGetReportsParams } from '../../../models/reports';
import { ReportsListDelegate } from '../../../services/DataDelegate/ReportsDelegate/reports.list.delegate';
import * as T_T from 'cryface';
import { formatDateTime } from '../../../utils/format.time';
import Datepicker from 'vue2-datepicker';
import * as moment from 'moment';
import { CommonConfig } from '../../../configs/config.common';

@Component(
   {
      components: {
         Datepicker
      }
   }
)
export default class ReportsList extends Vue {
   public title: string = 'ReportsList';

   public reportsData: IReportData = {};

   public dataDisplay: any = [];

   public reportsListDelegate = new ReportsListDelegate();

   public config = new CommonConfig();

   public totalItems = 100;

   public current = 1;

   public filterFormInline = {
      messageType: '',
      fromTime: '',
      fromDate: '',
      toTime: '',
      toDate: ''
   };
   public filterRuleInline = {
   };

   public datePickerLang = {
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
      placeholder: {
         date: 'Select Date',
         dateRange: 'Select Date Range'
      }
   };

   public timePicker: any[] = [
   ];

   public timePickerGenerator() {
      const result = [];
      for (let i = 1; i < 13; i++) {
         const index = i > 12 ? i - 12 : i;
         result.push(`${index}:00 PM`);
         result.push(`${index}:15 PM`);
         result.push(`${index}:30 PM`);
         result.push(`${index}:45 PM`);
         if (index === 11) {
            result.push(`${index}:59 PM`);
         }
      }
      for (let i = 1; i < 13; i++) {
         const index = i > 12 ? i - 12 : i;
         result.push(`${index}:00 AM`);
         result.push(`${index}:15 AM`);
         result.push(`${index}:30 AM`);
         result.push(`${index}:45 AM`);
      }
      return result;
   }

   public typeList = [
      {
         label: 'All Messages',
         value: ''
      },
      {
         label: 'Showing Request',
         value: 'showing_request'
      },
      {
         label: 'Other Message',
         value: 'other_message'
      }
   ];

   @Watch('$store.state.reports.list', { immediate: true, deep: true })
   public onReportsGotten(val: any, oldVal: any) {
      this.reportsData = val.data;
   }

   public created() {
      this.timePicker = this.timePickerGenerator();
      this.totalItems = this.reportsListDelegate.TotalItems;
      this.current = this.reportsListDelegate.CurrentPage;
      this.getReports();
   }

   public getReportsByCate(cate: string) {
      return T_T.simpleDetect(this.reportsData[cate]) ? this.reportsData[cate] : [];
   }

   public setReports(cate: string) {
      this.dataDisplay = this.getReportsByCate(cate);
   }

   public async getReports() {
      this.$store.commit('reportsStartFetching');
      const result = await this.reportsListDelegate.getReportsSummary();
      if (result !== 0) {
         this.$store.commit('updateReports');
      }
      this.$store.commit('reportsEndFetching');
   }

   public formatDT(timeDate: string) {
      return formatDateTime(timeDate);
   }

   public async handleDisplayCustom() {
      this.$store.commit('reportsStartFetching');
      const params: IGetReportsParams = {
      };
      if (T_T.simpleDetect(this.filterFormInline.messageType)) {
         params.smsType = this.filterFormInline.messageType;
      }
      if (T_T.simpleDetect(this.filterFormInline.fromDate) && T_T.simpleDetect(this.filterFormInline.fromTime)) {
         params.startTime = `${this._convertDate(this.filterFormInline.fromDate)} ${this._convertTime(this.filterFormInline.fromTime)}`;
      }
      if (T_T.simpleDetect(this.filterFormInline.toDate) && T_T.simpleDetect(this.filterFormInline.toTime)) {
         params.endTime = `${this._convertDate(this.filterFormInline.toDate)} ${this._convertTime(this.filterFormInline.toTime)}`;
      }
      const result = await this.reportsListDelegate.getCustom(params);
      if (result !== 0) {
         this.$store.commit('updateReports');
         this.setReports('custom');
      }
      this.$store.commit('reportsEndFetching');
   }

   private _convertTime(time: string) {
      let newTime = time;
      if (time.indexOf('AM') > -1) {
         newTime = time.replace('AM', '').trim();
      }
      if (time.indexOf('PM') > -1) {
         const hour = Number(time.replace('PM', '').trim().split(':')[0]) + 12;
         const minutes = time.replace('PM', '').trim().split(':')[1];
         newTime = `${hour}:${minutes}`;
      }
      newTime = `${newTime}:00`;
      return newTime;
   }

   private _convertDate(date: string) {
      return moment(date).format(this.config.dateFormat);
   }

   public destroyed() {
      this.reportsListDelegate.clearData();
   }
}
